import IPrayerSettings from "../interfaces/IPrayerSettings";

export const DefaultPrayerSettings: IPrayerSettings = {
    id: 0,
    timed: true,
    minimumPrayerTime: 30,
    sessionTime: 10,
    shuffle: false,
    alert: true,
    showSettings: true,
    nightMode: false,
    hapticAlert: true,
  }